"use strict";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _CardSection = _interopRequireDefault(require("../Card/CardSection"));

var _ = require("../..");

var _isMounted = _interopRequireDefault(require("../../hooks/isMounted"));

var _ArrowDownIcon = _interopRequireDefault(require("../Icons/ArrowDownIcon"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var ArrowDown = (0, _styledComponents.default)(_ArrowDownIcon.default).withConfig({
  displayName: "ArrowDown",
  componentId: "x2c4mi-0"
})(["margin-right:0.5rem;transition:transform 0.3s ease-in-out;"]);

var SectionContent = _styledComponents.default.div.withConfig({
  displayName: "SectionContent",
  componentId: "x2c4mi-1"
})([""]);

var Section = _styledComponents.default.div.withConfig({
  displayName: "Section",
  componentId: "x2c4mi-2"
})(["border-bottom:", ";background-color:", ";padding:0rem;&:last-child{border-bottom:none;}", "{position:relative;z-index:1;overflow:auto;transition:0.3s;&:first-child{display:flex;align-items:center;cursor:pointer;}", "{transition-timing-function:ease;transition-duration:0.2s;transition-property:opacity,transform;transition-delay:0.1s;}&[aria-expanded='false']{max-height:0;padding-top:0;padding-bottom:0;", "{opacity:0;transform:translateY(-1rem);}}&[aria-expanded='true']{max-height:100rem;padding:1rem;background:#fff;", "{opacity:1;transform:translateY(0);padding:0;}}}", " ", ""], function (_ref) {
  var _ref$border = _ref.border,
      border = _ref$border === void 0 ? '1px solid #d8d8d8' : _ref$border;
  return border;
}, function (_ref2) {
  var _ref2$backgroundColor = _ref2.backgroundColor,
      backgroundColor = _ref2$backgroundColor === void 0 ? 'unset' : _ref2$backgroundColor;
  return backgroundColor;
}, _CardSection.default, SectionContent, SectionContent, SectionContent, function (p) {
  return !p.open && (0, _styledComponents.css)(["", ":nth-last-child(2){border-bottom:1px solid transparent;transition:border-bottom 0.25s step-end;}"], _CardSection.default);
}, function (p) {
  return p.open && (0, _styledComponents.css)(["", "{transform:rotate(180deg);}"], ArrowDown);
});

var AccordionSection = function AccordionSection(_ref3) {
  var title = _ref3.title,
      spacing = _ref3.spacing,
      children = _ref3.children,
      onOpen = _ref3.onOpen,
      onClose = _ref3.onClose,
      _ref3$defaultOpen = _ref3.defaultOpen,
      defaultOpen = _ref3$defaultOpen === void 0 ? false : _ref3$defaultOpen,
      ariaExpanded = _ref3['aria-expanded'],
      _ref3$border = _ref3.border,
      border = _ref3$border === void 0 ? '1px solid #d8d8d8' : _ref3$border,
      _ref3$backgroundColor = _ref3.backgroundColor,
      backgroundColor = _ref3$backgroundColor === void 0 ? 'unset' : _ref3$backgroundColor,
      className = _ref3.className;
  var isMounted = (0, _isMounted.default)();

  var _useState = (0, _react.useState)(defaultOpen),
      _useState2 = _slicedToArray(_useState, 2),
      open = _useState2[0],
      setOpen = _useState2[1];

  (0, _react.useEffect)(function () {
    if (isMounted) {
      if (open && onOpen != null) {
        onOpen();
      } else if (onClose != null) {
        onClose();
      }
    }
  }, [open]);

  var cardClick = function cardClick() {
    setOpen(!open);
  };

  (0, _react.useEffect)(function () {
    if (ariaExpanded === undefined) {
      return;
    }

    setOpen(ariaExpanded);
  }, [ariaExpanded]);
  return _react.default.createElement(Section, {
    open: open,
    border: border,
    backgroundColor: backgroundColor,
    className: className
  }, _react.default.createElement(_CardSection.default, {
    onClick: cardClick,
    border: border
  }, _react.default.createElement(ArrowDown, {
    title: null
  }), typeof title === 'string' ? _react.default.createElement(_.Strong, null, title) : title), _react.default.createElement(_CardSection.default, {
    spacing: spacing,
    "aria-expanded": open,
    border: border
  }, _react.default.createElement(SectionContent, null, children)));
};

var _default = (0, _styledComponents.default)(AccordionSection).withConfig({
  componentId: "x2c4mi-3"
})([""]);

exports.default = _default;